import { VALID_WAREHOUSE_ROUTES, VALID_USER_ROUTES, VALID_SELLER_PLUS_WAREHOUSE_ROUTES, COMMON_ROUTES, INACTIVE_RESTRICTED_ROUTES } from '../constants/routes';

const handleRouteValidations = (data, currentPath) => {
  const { user } = data || {};

  const {
    role,
    is_active
  } = user || {};

  const isOwner = user?.email == 'mike@opulent.com';
  const isWarehouse = role?.name === 'Warehouse';
  const isAdmin = (user?.role_id == 1 || user?.role_id == 3);
  const isWarehouseWorker = user?.warehouse_manager_id;
  const isSellerPlusWarehouse = user?.role_id == 5;
  const isSeller = user?.role_id == 2;
  const isValidWarehouseRoute = VALID_WAREHOUSE_ROUTES.some(route =>
    currentPath.startsWith(route)
  );

  const message = 'You are not allowed to do this action';
  const redirectTo = '/inventory/sku';
  const isRestrictedRoute = (route) => {
    return INACTIVE_RESTRICTED_ROUTES.some(pattern => {
      if (pattern.endsWith('/')) {
        return route.startsWith(pattern);
      }
      return route === pattern;
    });
  };

  // Check if route is in COMMON_ROUTES (supports dynamic routes starting with common routes)
  const isCommonRoute = COMMON_ROUTES.some(route => 
    currentPath === route || currentPath.startsWith(route + '/')
  );

  // if (isSellerPlusWarehouse && !VALID_SELLER_PLUS_WAREHOUSE_ROUTES.includes(currentPath)) return { success: false, message, redirectTo }
  if (isWarehouse && !isValidWarehouseRoute) return { success: false, message, redirectTo: '/warehouse-location' };
  if (isSeller && !isCommonRoute && isValidWarehouseRoute) {
    return { success: false, message, redirectTo };
  }
  if ((isSeller || isSellerPlusWarehouse) && !is_active && isRestrictedRoute(currentPath)){
    return { success: false, message: 'Your account is inactive. Please contact support.', redirectTo: '/inventory/sku' };
  }


  if (currentPath === '/admin/user' && !isOwner) return { success: false, message, redirectTo };
  if (currentPath === '/vendors' && (isWarehouseWorker )) return { success: false, message, redirectTo };
  if (currentPath === '/warehouse-vendors' && !isAdmin) return { success: false, message, redirectTo };

  return { success: true };
};

export default handleRouteValidations;
